// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Row, Column } from '../../ui/layout';
import { loadBuildings } from '../../../libs/buildings';
import { connect } from 'react-redux';
import BuildingCard from './BuildingCard';

const BuildingColumn = styled.div`
  max-width: 20%;
  flex: 0 0 20%;
  padding: 5px;
  box-sizing: border-box; 
`;

const LoadMoreButton = styled.a`
  color: white;
  width: 95%;
  margin: 10px auto;
  text-align: center;
  padding: 10px;
  display: block;
  cursor: pointer;
  background: ${props => props.background};
`;

const Empty = styled.div`
  color: white;
  font-size: 14px;
  text-align: center;
  display: block;
  margin-top: 30px;
  width: 100%;
`;

class BuildingsResult extends PureComponent {
  state = {
    buildings: [],
    page: 0,
    isLoading: true,
  }

  componentDidMount() {
    if (this.props.clientInf) {
      this.initBuildings(this.props.query, this.props.clientInf.clients_id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.clientInf !== nextProps.clientInf ||
      this.props.query !== nextProps.query
    ) {
      this.initBuildings(nextProps.query, nextProps.clientInf.clients_id);
    }
  }

  initBuildings = async (query, cid) => {
    this.setState({
      isLoading: true,
    });
    const { model, count } = await loadBuildings({
      ...query,
      id: cid,
    });
    const page = query.page || 0;
    const buildings = page === 0 ? model : [...this.state.buildings, ...model];
    this.setState({
      count: parseInt(count, 10),
      isLoading: false,
      buildings,
      page,
    });
  }

  loadNextPage = () => {
    const nextPage = this.state.page + 1;
    this.initBuildings({ ...this.props.query, page: nextPage }, this.props.clientInf.clients_id);
  }

  props: {
    query: Object,
    clientInf: Object,
    pageInfo: Object,
  }

  render() {
    const totalPages = Math.ceil(this.state.count / 15);
    const nextPage = this.state.page + 1;
    return (
      <div>
        <Row>
          {this.state.buildings.map(detail => (
            <BuildingColumn key={detail.id}>
              <BuildingCard
                detail={detail}
              />
            </BuildingColumn>
          ))}
          {!this.state.isLoading && this.state.buildings.length === 0 && (
            <Empty>No se han encontrado propiedades que coincidan con la busqueda</Empty>
          )}
        </Row>
        {nextPage < totalPages && this.props.pageInfo && (
          <LoadMoreButton onClick={this.loadNextPage} background={this.props.pageInfo.page.color_base}>Cargar más propiedades</LoadMoreButton>
        )}
      </div>
    )
  }
}

export default connect(state => ({
  clientInf: state.client.info,
  pageInfo: state.client.pageInfo,
}))(BuildingsResult);



// WEBPACK FOOTER //
// ./src/components/BuildingsView/BuildingsResult/index.js